import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import TableComponent from "../components/TableComponent";
import { BULK_ASSIGN_HEADERS, DASHBOARD_HEADERS } from "../pages/dashboard/DashboardHelper";
import { ColumnHeaderType, LoggedUserType } from "../utils/Types";
import { FormUtils } from "../utils/FormUtils";
import SelectInput from "../components/SelectInput";
import { useForm } from "react-hook-form";
import { checkNullValue, getDepartmentData, getUpdateLobData } from "../utils/Util";
import { mapLOBMaster, mapMasters } from "../utils/MastersMapping";
import { getAllUsersByDepartment } from "../api/roleMasterApi";
import { loginSelector } from "../redux/slices/loginSlice";
import SelectBox from "../components/SelectBox";
import { bulkAssignAPi } from "../api/grievancesApi";
import { handleBulkAssignResponse } from "../redux/slices/grievancesSlice";
import { toast } from "react-toastify";
import { LINE_OF_BUSINESS, ROLE_ID, STATUS } from "../utils/Constant";

interface BulkAssignForm {
    department: string;
    spoc: string;
    lineOfBusiness: string;
}

const BulkAssignModal = (props: any) => {
    const { toggle, openModal, selectedData, selectedCount, setSelectedCount } = props;
    const dispatch: any = useDispatch();
    const user: LoggedUserType = useSelector(loginSelector).user;
    const [spocList, setSpocList] = useState<any>([]);
    const [departmentList, setDepartmentList] = useState<any>([{value: 1, label: 'GRO'}]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState<boolean | undefined>(true);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [columnHeaders, setColumnHeaders] = useState(BULK_ASSIGN_HEADERS);
    const [submitData, setSubmitData] = useState<any[]>([]);

    const additional_columns = [
        {value: 1, label: 'Line of Business'},
        {value: 2, label: 'Type of Request'},
        {value: 3, label: 'Turn Around Time'},
        {value: 4, label: 'Aging'},
        {value: 5, label: 'Name'},
        {value: 6, label: 'Mobile Number'},
        {value: 7, label: 'Policy Number'},
        {value: 8, label: 'Reference No.'},
        {value: 9, label: 'Source of Complaint'},
        {value: 10, label: 'Mode of Complaint'},
        {value: 11, label: 'Date of Closure'}
    ]

    const {
        storeDepartmentData,
        storeLOBData,
        storeBulkAssignResponse
    } = useSelector((state: any) => state.grievances);

    const {
        storeUserListByDepartment
    } = useSelector((state: any) => state.roleMaster);

    const departmentData = getDepartmentData(
        storeDepartmentData.data ?? []
    );

    const lobData = getUpdateLobData(FormUtils.convertDataList(
        storeLOBData?.data ?? []
    ));

    const closeBtn = (
        <img src={require('../assets/img/close_modal.svg').default} onClick={() => { toggle(false);}} style={{ cursor: 'pointer' }}></img>
    );

    const onTableAction = (each: any, headerItem: ColumnHeaderType) => {
    };

    const data = useForm<BulkAssignForm>({
        defaultValues: {
            department: '',
            spoc: '',
            lineOfBusiness: '',
        },
        mode: 'all',
    });

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        formState: { errors },
    } = useForm<BulkAssignForm>()

    const department = watch('department');
    const spoc = watch('spoc');
    const lineOfBusiness = watch('lineOfBusiness');

    const onChangeInput = (label: any, value: any,) => {
        setValue(label, value, { shouldValidate: true })
    }

    const onSubmit = (data: BulkAssignForm) => {
        let selectedData = selectedRows.map((each: any) => {
            return {
                grievanceId: each,
                department: mapMasters(data?.department, departmentData),
                spoc: data?.spoc
            }
        })
        setSubmitData(selectedData);
        dispatch(bulkAssignAPi(selectedData))
    }

    useEffect(() => {
        let data = selectedData?.filter((each: any)=> {
            return each?.status !== STATUS.CLOSE;
        })?.map((each: any)=>{
            return each?.grievanceId;
        });
        setSelectedRows(data)
        setSelectedCount(data?.length)
    }, [selectedData])

    useEffect(() => {
        const filtered_ids = selectedRows?.filter(id => {
            const grievance_obj = selectedData.find((o: any) => o.grievanceId === id);
            return grievance_obj && (grievance_obj.status !== STATUS.CLOSE);
        });
        setSelectedCount(filtered_ids?.length)
    }, [selectedRows])

    useEffect(() => {
        if (storeBulkAssignResponse?.statusId == 200) {
            toggle(true)
            dispatch(handleBulkAssignResponse({}));
            toast.success('Bulk Assignment Successful');
        }
        else{
            storeBulkAssignResponse?.statusId && storeBulkAssignResponse?.statusId !== 200 && toast.error('Bulk Assignment Failed');
        }
    }, [storeBulkAssignResponse])

    useEffect(() => {
        const newHeaders = [...BULK_ASSIGN_HEADERS];
        selectedColumns.forEach((each: any) => {
            const found = DASHBOARD_HEADERS.find(obj => obj.name === each.label);
            if (found) {
                let headers = {...found, searchable: false}
                newHeaders.push(headers);
            }
        });

        setColumnHeaders(newHeaders);
    }, [selectedColumns]);

    useEffect(() => {
        setValue('department', '', { shouldValidate: true });
        setValue('spoc', '', { shouldValidate: true });
        let data = selectedData?.filter((each: any)=> {
            return mapLOBMaster(lineOfBusiness) == each?.lobId && each?.status !== STATUS.CLOSE;
        })?.map((each: any)=>{
            return each?.grievanceId;
        });
        lineOfBusiness && setSelectedCount(data?.length)
        setSelectedRows(data);
    },[lineOfBusiness])

    useEffect(() => {
        setSpocList([]);
        setValue('spoc', '', { shouldValidate: true });
        if(department && mapMasters(department, departmentData) != 14){
            dispatch(getAllUsersByDepartment(department));
        }
    },[department])

    useEffect(() => {
        if(storeUserListByDepartment?.length > 0){
            let list: any = [];
            storeUserListByDepartment.map((user: any, i: number) => {
            list.push({value: i, label: `${user.firstName} ${user.lastName ? user.lastName : ''}`})
            })
            setSpocList(list);
        }
    },[storeUserListByDepartment])

    useEffect(() => {
        let filteredDepartmentData = departmentData.filter((department: any) => 
                (department.label !== 'Super Admin' && department.label !== 'PMFBY' && checkNullValue(department?.lobId) !== 'N/A') || (department?.label == 'GRO')
        );
        filteredDepartmentData = filteredDepartmentData.filter((department: any) => {
            if (mapLOBMaster(lineOfBusiness) === LINE_OF_BUSINESS.TO_BE_ASSIGNED) {
                return true;
            } else if ((department?.label == 'GRO')) {
                return department;
            } else {
                return department?.lobId === mapLOBMaster(lineOfBusiness);
            }
        });

        if (user.roleId === ROLE_ID.GRO || user.roleId === ROLE_ID.AGENT || user.roleId === ROLE_ID.SUPER_ADMIN) {
            setDepartmentList(filteredDepartmentData);
        } else {
            filteredDepartmentData = filteredDepartmentData?.filter((department: any) => {
                return user?.roleName?.includes(department?.label) || department?.label === 'GRO'
            })
            setDepartmentList(filteredDepartmentData);
        }
    }, [user, departmentData, lineOfBusiness]); 

    return (
        <Modal isOpen={openModal} toggle={toggle} centered={true} backdrop={'static'} size={"xl"} className="modal-size-custom">
            <ModalHeader toggle={toggle} close={closeBtn}>
                Bulk Assignment
            </ModalHeader>
            <ModalBody>
                <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <Row>
                        <Col xs={6} md={4} className="mb-3">
                            <SelectInput
                                label="Line of Business"
                                changeFun={onChangeInput}
                                valueName={'lineOfBusiness'}
                                register={register('lineOfBusiness')}
                                formValue={lineOfBusiness}
                                errors={errors}
                                data={lobData}
                                required={true}
                            />
                        </Col>
                        <Col xs={6} md={4} className="mb-3">
                            <SelectInput
                                label="Department"
                                changeFun={onChangeInput}
                                valueName={'department'}
                                register={register('department')}
                                formValue={department}
                                errors={errors}
                                data={departmentList}
                                required={true}
                                disabled={(!lineOfBusiness)}
                            />
                        </Col>
                        <Col xs={6} md={4} className="mb-3">
                            <SelectInput
                                label="SPOC"
                                changeFun={onChangeInput}
                                valueName={'spoc'}
                                register={register('spoc')}
                                formValue={spoc}
                                errors={errors}
                                data={spocList}
                                required={true}
                                disabled={(!department || mapMasters(department, departmentData) === 14)}
                            />
                        </Col>
                    </Row>

                    <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                        <p style={{ fontSize: '14px', margin: '10px 0 0 0'}}>No. of Records: {selectedCount}/{selectedData?.length}</p>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                            <div style={{width: '40vw'}}>
                                <SelectBox
                                    options={additional_columns}
                                    isMulti={true}
                                    className="css-select-bg"
                                    placeholder="Select to add columns"
                                    onChange={(value: any) => {
                                        setSelectedColumns(value)
                                    }}
                                />
                            </div>
                            <button 
                                className='create-grievance' 
                                type="submit"
                                disabled={!(selectedCount > 0) || !user?.permissions?.includes('assign-spoc')}
                            > 
                                Assign to SPOC 
                            </button>
                        </div>
                    </div>
                </form>

                <div className="table-container">
                    <TableComponent 
                        columnHeaders={columnHeaders}
                        onAction={onTableAction}
                        data={selectedData} 
                        masterData={departmentData}
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        selectAll={selectAll}
                        setSelectAll={setSelectAll}
                        selectedLOB={mapLOBMaster(lineOfBusiness)}
                        deSelectClose={true}
                    />
                </div>
            </ModalBody>
        </Modal>
    );
}


export default BulkAssignModal;